const SET_BANK_LIST = (state, payload) => {
    state.bank.list = payload
}

export default {
    SET_BANK_LIST
}
